import { Navbar } from "@/components/Navbar";
import { SpanishHero } from "@/components/SpanishHero";
import { SpanishServices } from "@/components/SpanishServices";
import { SpanishWhyUs } from "@/components/SpanishWhyUs";
import { SpanishTestimonials } from "@/components/SpanishTestimonials";
import { SpanishFAQ } from "@/components/SpanishFAQ";
import { SpanishFinalCTA } from "@/components/SpanishFinalCTA";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";
import { StickyBanner } from "@/components/StickyBanner";
import { LocationContext } from "@/lib/locations";
import { WaitlistPopup } from "@/components/WaitlistPopup";

const location = {
  slug: "fremont",
  name: "Fremont",
  type: "city" as const,
  regionSlug: "alameda" as const,
};

const FremontSpanishPage = () => (
  <LocationContext.Provider value={location}>
    <SEO
      title="Limpieza del Hogar en Fremont, CA | Uplevel Cleaning"
      description="Servicio profesional de limpieza del hogar en Fremont. Precios transparentes, reserva en 60 segundos, garantía de satisfacción del 200%. ¡Llama hoy!"
      keywords="limpieza del hogar Fremont, servicio de limpieza Fremont CA, limpieza profunda Fremont, mucama Fremont, limpieza residencial Fremont"
      url="https://uplevelcleaning.com/es/fremont"
      locationName="Fremont"
      regionSlug="alameda"
      lang="es"
      includeLocalBusiness
      includeFAQ
      breadcrumbs={[
        { name: "Inicio", url: "/" },
        { name: "Condado de Alameda", url: "/locations/alameda" },
        { name: "Fremont (Español)", url: "/es/fremont" },
      ]}
      reviews={[
        { author: "Rosa M.", rating: 5, reviewBody: "El mejor servicio de limpieza en Fremont. Puntuales, profesionales y muy detallistas.", datePublished: "2026-03-10" },
        { author: "Carlos V.", rating: 5, reviewBody: "Reservé en línea en minutos y el resultado fue increíble. Mi hogar quedó impecable.", datePublished: "2026-02-18" },
        { author: "Linda T.", rating: 5, reviewBody: "Precios justos, sin sorpresas. El equipo fue muy respetuoso con nuestra casa.", datePublished: "2026-01-25" },
      ]}
    />
    <WaitlistPopup />
    <div className="flex min-h-screen flex-col">
      <StickyBanner />
      <Navbar />
      <main className="flex-1">
        <SpanishHero cityName="Fremont" regionSlug="alameda" />
        <SpanishWhyUs cityName="Fremont" />
        <SpanishServices />
        <SpanishTestimonials region="alameda" />
        <SpanishFAQ cityName="Fremont" />
        <SpanishFinalCTA cityName="Fremont" />
      </main>
      <Footer />
    </div>
  </LocationContext.Provider>
);

export default FremontSpanishPage;
